export default __webpack_public_path__ + "static/media/plugged_icon.8e10d294.svg";